var MuiListItem = {
/* put your new default props here */
};
export default MuiListItem;
//# sourceMappingURL=MuiListItem.js.map